import Vue from "vue";
import "./plugins/bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import firebase from "firebase/app";
import vueHeadful from "vue-headful";
import VueMeta from "vue-meta";
import Clipboard from "v-clipboard";
import "native-toast/dist/native-toast.css";
// Self-hosted so no request goes to Google Fonts / cdnjs before consent.
import "@fontsource/indie-flower";
import "animate.css/animate.min.css";
import nativeToast from "native-toast";
import i18n, { loadLocale } from "./i18n";
import { installHreflang } from "./seo/hreflang";
import PostHogPlugin, { posthog } from "./plugins/posthog";
Vue.use(Clipboard);
Vue.use(PostHogPlugin);

router.afterEach(to => {
  Vue.nextTick(() => {
    posthog.capture("$pageview", { $current_url: window.location.origin + to.fullPath });
  });
});

Vue.config.productionTip = false;

//use headful
Vue.component("vue-headful", vueHeadful);
Vue.use(VueMeta);

installHreflang({ router, defaultLocale: "en" });

// use beforeEach route guard to set the language
router.beforeEach(async (to, from, next) => {
  // use the language from the routing param or default language
  const language = to.params.lang || "en";

  try {
    await loadLocale(language);
    next();
  } catch (error) {
    console.error(`Could not load locale "${language}"`, error);

    nativeToast({
      message: i18n.t("localeLoadError"),
      position: "north-east",
      timeout: 4000,
      type: "error",
    });

    // Keep the current page usable when a locale chunk cannot be downloaded.
    // On the initial visit, English is bundled and is always available.
    if (from.matched.length) {
      next(false);
    } else {
      await loadLocale("en");
      next();
    }
  }
});

// google firebase setup
var firebaseConfig = {
  apiKey: "AIzaSyCySUeBq5nu2qvGOYR8oh9XZytV_6eqiS8",
  authDomain: "list2go-2bc71.firebaseapp.com",
  databaseURL: "https://list2go-2bc71.firebaseio.com/",
  projectId: "list2go-2bc71",
  storageBucket: "",
  messagingSenderId: "1047047805199",
  appId: "1:1047047805199:web:e63fdf7f156d553e03467a",
  measurementId: "G-8MZLTXK0J4",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

window.firebase = firebase;

// Set up the dataLayer
window.dataLayer = window.dataLayer || [];

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount("#app");
